<template>
  <v-card class="filter-bar" elevation="2">
    <v-card-text>
      <v-row align="center">
        <v-col cols="12" sm="auto">
          <div class="filter-label">FILTROS</div>
        </v-col>

        <v-col cols="12" sm="3" md="2">
          <v-select
            v-model="localFilters.dateRange"
            :items="dateRangeOptions"
            dense
            outlined
            hide-details
          />
        </v-col>

        <v-col v-if="localFilters.dateRange === 'custom'" cols="12" sm="3" md="2">
          <v-text-field
            v-model="localFilters.startDate"
            type="date"
            dense
            outlined
            hide-details
            label="De"
          />
        </v-col>

        <v-col v-if="localFilters.dateRange === 'custom'" cols="12" sm="3" md="2">
          <v-text-field
            v-model="localFilters.endDate"
            type="date"
            dense
            outlined
            hide-details
            label="Ate"
          />
        </v-col>

        <v-col cols="12" sm="3" md="2">
          <v-select
            v-model="localFilters.channel"
            :items="channelOptions"
            dense
            outlined
            hide-details
          />
        </v-col>

        <v-col cols="12" sm="3" md="2">
          <v-select
            v-model="localFilters.status"
            :items="statusOptions"
            dense
            outlined
            hide-details
          />
        </v-col>

        <v-col cols="auto">
          <v-btn color="primary" @click="$emit('refresh')">
            <v-icon left>mdi-refresh</v-icon>
            Atualizar
          </v-btn>
        </v-col>

        <v-col cols="auto" class="ml-auto">
          <v-checkbox
            :input-value="autoRefresh"
            label="Auto-refresh"
            dense
            hide-details
            @change="$emit('update:autoRefresh', $event)"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'FilterBar',
  props: {
    filters: { type: Object, required: true },
    channels: { type: Array, default: () => [] },
    autoRefresh: { type: Boolean, default: true }
  },
  data () {
    return {
      localFilters: { ...this.filters }
    }
  },
  computed: {
    dateRangeOptions () {
      return [
        { text: 'Hoje', value: 'today' },
        { text: 'Ultimos 7 dias', value: 'last7' },
        { text: 'Ultimos 30 dias', value: 'last30' },
        { text: 'Customizado', value: 'custom' }
      ]
    },
    channelOptions () {
      return [
        { text: 'Todos os canais', value: 'all' },
        ...this.channels.map((c) => ({ text: c, value: c }))
      ]
    },
    statusOptions () {
      return [
        { text: 'Todos os status', value: 'all' },
        { text: 'Abertos', value: 'open' },
        { text: 'Fechados', value: 'closed' }
      ]
    }
  },
  watch: {
    localFilters: {
      deep: true,
      handler: function (val) {
        this.$emit('update:filters', val)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.filter-bar {
  border-radius: 16px;
}

.filter-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.15em;
  color: #410E47;
}
</style>
